import find from 'lodash/find';
import inRange from 'lodash/inRange';
import get from 'lodash/get';
import { isPointInsidePolygon } from './storeUtils';

export const orderDeliveryFee = (ranges, bundlesAmount, userDistance) => {
  const amountRange = find(ranges, ({ amount }) => inRange(bundlesAmount, amount[0], amount[1] || Infinity));
  const radiusRange = find(get(amountRange, 'radius', []), ({ distance }) =>
    inRange(userDistance, distance[0], distance[1] || Infinity)
  );
  return get(radiusRange, 'fee', 0);
};

export const orderDeliveryAreaFee = (geoCoordinates, deliveryAreas, basketValue) => {
  let fee = Infinity;
  let minValue = Infinity;
  let existsEligibleArea = false;

  if (!geoCoordinates || !geoCoordinates.longitude || !geoCoordinates.latitude || !deliveryAreas || !Array.isArray(deliveryAreas)) {
    return { fee: 0, minValue: 0 };
  }

  const addressGeolocation = { lat: +geoCoordinates.latitude, lng: +geoCoordinates.longitude };

  deliveryAreas.forEach((area) => {
    if (!isPointInsidePolygon(addressGeolocation, area.positioningData.path)) return;

    existsEligibleArea = true;

    area.deliveryFees.forEach((deliveryFee) => {
      if (inRange(basketValue, deliveryFee.amount[0], deliveryFee.amount[1] || Infinity) && fee > deliveryFee.fee) {
        fee = deliveryFee.fee;
      }
    });

    const areaMinValue = area.deliveryFees.sort((a, b) => a.amount[0] - b.amount[0])[0].amount[0];

    if (areaMinValue < minValue) {
      minValue = areaMinValue;
    }
  });

  return existsEligibleArea ? { fee, minValue } : { fee: 0, minValue: 0 };
};
